import React from 'react';
import { useHistory } from 'react-router-dom';
import { NumericFormat } from 'react-number-format';
export default function ResourceListItem(props) {
    const { title, url, uid, addresses, amount, recipient } = props.data;
    const { city, county, region, state } = (addresses === null || addresses === void 0 ? void 0 : addresses[0]) || {};
    const { globalConfig, openModalItem, selectItem, isSelected } = props;
    const { baseRoute } = globalConfig;
    const cleanTitle = title.replace(/[\[\]]/g, '');
    const history = useHistory();
    let location;
    if (city) {
        location = `${city}, ${state}`;
    }
    else if (!location && county) {
        location = `${county} County, ${state}`;
    }
    else if (!location && region) {
        location = region;
    }
    else {
        location = 'Statewide';
    }
    ;
    const handleClick = () => {
        openModalItem(uid);
        history.replace(url === null || url === void 0 ? void 0 : url.replace(baseRoute, ''));
    };
    const handleMouseOver = () => {
        selectItem([uid]);
    };
    const handleMouseLeave = () => {
        selectItem([]);
    };
    return (React.createElement("div", { className: `EventListItem${isSelected ? ' selected' : ''}`, onClick: handleClick, onMouseOver: handleMouseOver, onMouseOut: handleMouseLeave },
        location && (React.createElement("div", { className: "EventListItem__city Heading Heading--overline" }, location)),
        React.createElement("div", { className: "EventListItem__title" },
            amount && (React.createElement("span", { className: "EventListItem__amount" },
                "$",
                React.createElement(NumericFormat, { displayType: "text", value: amount, thousandSeparator: "," }))),
            cleanTitle || recipient)));
}
;
